export const buildInlineSelectStyles = ({ theme }) => ({
  input: base => ({
    ...base,
    color: theme.palette.text.primary,
    display: 'flex',
    flex: 1,
    '& input': {
      font: 'inherit'
    }
  }),
  indicatorsContainer: base => ({
    ...base,
    cursor: 'pointer'
  }),
  menu: base => ({
    ...base,
    zIndex: 1300
  })
});
